import { IFilterComplete } from '../../filter-complete/filter-complete';

export class RelevancePatientFilter implements IFilterComplete {
  public Name: string;
  public Id: number;
  public BlockEdit: boolean;
}
